<template>
  <Modal
    name="VERIFY_HOST_ONBOARDING"
    :title="'Confirmar verificação do Host'"
  >
    <template v-slot:body>
      <div>
        <v-row class="mb-2">
          <v-col>
            <p>
              Você está prestes a fazer uma verificação do histórico pessoal para "{{host.name}}", essa ação gerará custos à Hauseful.
            </p>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col>
            <v-btn @click="closeModal('VERIFY_HOST_ONBOARDING')" outlined color="primary">
              Cancelar
            </v-btn>
          </v-col>
          <v-col class="d-flex justify-end">
            <v-btn @click="createHostBackgroundCheck(host.id)" :loading="isLoadingButton" color="primary">
              Confirmar
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import FilterSearch from '@/components/filters/FilterSearch'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ModalVerifyHostOnboarding',

  props: {
    host: {
      type: Object,
    },
  },

  components: {
    Modal,
    FilterSearch,
  },

  computed: {
    ...mapGetters(['isLoadingButton']),
  },

  methods: {
    ...mapActions(['closeModal', 'createHostBackgroundCheck']),
  },
}
</script>
